import React from "react";
import Rotate from "./Rotate";
import UndoRedo from "./UndoRedo";
import "./LeftControls.css";

const LeftControls = () => {
  return (
    <div className="canvas-controls canvas-controls--left">
      <Rotate />
      <UndoRedo />
    </div>
  );
};

export default LeftControls;
